module.exports = __webpack_public_path__ + "static/media/newLogo.5ad86d43.jpg";